let i18next = require('i18next');

module.exports = function (data, options) {
    return i18next.t(data);
};



// WEBPACK FOOTER //
// ./src/scripts/core/templates/templates/i18n.js